import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopNav } from './Navigation/TopNav';
import { Footer } from './Layout/Footer';
import { useRouteMetaTags } from '../hooks/useRouteMetaTags';

export function Layout() {
  useRouteMetaTags();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <TopNav />
      <main className="pt-16">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}